import { useAssetPreviewForCopyQuery } from '~generated/hooks'

/* eslint-disable import/prefer-default-export */
export function useAssetPreviewForCopy(assetId: string) {
  const { data: { asset } = {}, loading } = useAssetPreviewForCopyQuery({
    variables: {
      id: assetId,
    },
  })

  return [asset, loading] as const
}
